import React, { ReactElement } from "react";

import { Button } from "@lmc/ui-kit";
import Icon from "../../general/Icon";
import { Dropdown } from "antd";
import { ButtonVariant } from "@lmc/ui-kit/src/general/Button/Button";

export type DropdownButtonProps = {
  buttonText: string;
  overlay: ReactElement;
  style?: React.CSSProperties;
  type: ButtonVariant;
  testId?: string;
};

export default function DropdownButton({
  buttonText,
  overlay,
  style,
  type,
  testId,
}: DropdownButtonProps): ReactElement {
  const containerStyle = {
    ...styles.container,
    ...style,
  };

  return (
    <div style={containerStyle} data-testid={testId}>
      <Dropdown overlay={overlay} trigger={["click"]}>
        <Button variant={type}>
          <div style={styles.dropdownBtn}>
            <div>{buttonText}</div>
            <Icon name="DownOutlined" style={styles.dropdownIcon} />
          </div>
        </Button>
      </Dropdown>
    </div>
  );
}

const styles = {
  dropdownBtn: {
    display: "flex",
    alignItems: "center",
  },
  dropdownIcon: {
    marginLeft: 8,
  },
  container: {
    display: "flex",
    alignItems: "center",
  },
};
